import styled from 'styled-components'

export default styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  font-size: 1.4rem;

  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1270px) {
    max-width: 1240px;

    .content-item {
      max-width: 50rem;
    }
  }

  .content {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 4rem;
  }

  .footer {
    text-align: center;
    font-size: 1.8rem;
    font-weight: bold;
  }

  .footer_price {
    text-align: center;
    font-size: 2.4rem;
    font-weight: bold;
    margin-top: 0.5rem;
  }

  .hour_purchase_info {
    font-size: 1.8rem;
    max-width: 50rem;
    text-align: center;
  }

  .price {
    font-size: 2.8rem;
    font-weight: bold;
    text-align: center;
  }

  .saving {
    width: 100%;
    text-align: right;
    font-size: 2rem;
    font-weight: bold;
    color: #e41645;
  }

  .text_button {
    background: transparent;
    border: 0;
    outline: none;
    color: #e41645;
    font-weight: bold;
    cursor: pointer;
  }

  .agree {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
`
